/** Matches a country translation key (`country.be`, `country.gb_eng`) and captures the ISO code. */
export const COUNTRY_TRANSLATION_KEY = /^country\.([a-z_]+)$/i;
